module.exports = __webpack_public_path__ + "src/assets/textures/env/tractor/tractor_rear_wheels_2k_bake.png";